















import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ProductDetail from '@/views/product/widgets/ProductDetail.vue';
import { Route } from 'vue-router';
import { ProductTuple } from '@/stores/search/util';
import { ProductDetailStore } from '@/stores/product/product-detail.store';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import { CategoryDto } from '@/api';
import ProductBreadcrumbs from '@/views/product/widgets/ProductBreadcrumbs.vue';
import Routes from '@/util/Routes';

@Component({
  components: {
    LoadingIndicator,
    ProductDetail,
    ProductBreadcrumbs,
  },
})
export default class ProductDetailView extends Vue {
  private loading = true;
  private detailStore = getModule(ProductDetailStore, this.$store);

  @Prop({required: true})
  private unitAbbreviation!: string;

  @Prop({required: true})
  private sku!: string;

  public async mounted(): Promise<void> {
    try {
      await this.detailStore.fetchBySkuAndUnit({
        sku: this.sku, unitAbbreviation: this.unitAbbreviation,
      });
    } finally {
      this.loading = false;
    }
    window.scrollTo(0, 0);
  }

  public get productTuple(): ProductTuple | null {
    return this.detailStore.productTuple;
  }

  public get parentCategory(): CategoryDto | null {
    return this.detailStore.productTuple?.product?.directCategory ?? null;
  }

  public async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    // Component is not re-mounted when only params change (e.g. SKU)
    // ref: https://router.vuejs.org/guide/advanced/navigation-guards.html#navigation-guards
    this.loading = true;
    try {
      await this.detailStore.fetchBySkuAndUnit({
        sku: to.params.sku, unitAbbreviation: to.params.unitAbbreviation,
      });
    } finally {
      this.loading = false;
    }
    next();
  }

  public routeBack() {
    if (this.$route.meta.origin) {
      this.$router.push({path: this.$route.meta.origin});
    } else {
      this.$router.push({name: Routes.Home});
    }
  }
}
